export default "__VITE_ASSET__DAogKO4D__"